import { createBrowserRouter } from "react-router";
import { Home } from "./pages/Home";
import { Angebot } from "./pages/Angebot";
import { Ablauf } from "./pages/Ablauf";
import { Preise } from "./pages/Preise";
import { Softwareentwicklung } from "./pages/Softwareentwicklung";
import { Fragebogen } from "./pages/Fragebogen";
import { Login } from "./pages/Login";
import { AccountSetup } from "./pages/AccountSetup";
import { OrderSuccess } from "./pages/OrderSuccess";
import { Dashboard } from "./pages/Dashboard";
import { ProjectCheckout } from "./pages/ProjectCheckout";
import { AdminDashboard } from "./pages/AdminDashboard";
import { AdminCustomers } from "./pages/AdminCustomers";
import { AdminProjectDetail } from "./pages/AdminProjectDetail";
import { DraftPreview } from "./pages/DraftPreview";
import { Agb } from "./pages/Agb";
import { Impressum } from "./pages/Impressum";
import { Datenschutz } from "./pages/Datenschutz";
import { Widerruf } from "./pages/Widerruf";
import { Blog } from "./pages/Blog";
import { BlogPost } from "./pages/BlogPost";
import { NotFound } from "./pages/NotFound";
import { ProfessionelleWebsiteOhneAufwand } from "./pages/ProfessionelleWebsiteOhneAufwand";
import { Standorte } from "./pages/Standorte";
import { WebdesignDresden } from "./pages/WebdesignDresden";
import { WebdesignSenftenberg } from "./pages/WebdesignSenftenberg";
import { WebdesignRuhland } from "./pages/WebdesignRuhland";
import { WebdesignSchwarzheide } from "./pages/WebdesignSchwarzheide";
import { WebdesignHoyerswerda } from "./pages/WebdesignHoyerswerda";
import { WebdesignMeissen } from "./pages/WebdesignMeissen";
import { WebdesignerDresden } from "./pages/WebdesignerDresden";
import { WebsiteErstellenLassenDresden } from "./pages/WebsiteErstellenLassenDresden";
import { Layout } from "./components/Layout";
import { DashboardLayout } from "./components/DashboardLayout";
import { AdminLayout } from "./components/AdminLayout";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { AdminRoute } from "./components/AdminRoute";
import { RootProvider } from "./components/RootProvider";
import { RouteErrorPage } from "./components/RouteErrorPage";

export const router = createBrowserRouter([
  {
    element: <RootProvider />,
    errorElement: <RouteErrorPage />,
    children: [
      {
        path: "/",
        Component: Layout,
        children: [
          { index: true, Component: Home },
          { path: "angebot", Component: Angebot },
          { path: "ablauf", Component: Ablauf },
          { path: "preise", Component: Preise },
          { path: "softwareentwicklung", Component: Softwareentwicklung },
          {
            path: "professionelle-website-ohne-aufwand",
            Component: ProfessionelleWebsiteOhneAufwand,
          },
          { path: "standorte", Component: Standorte },
          { path: "webdesign-dresden", Component: WebdesignDresden },
          { path: "webdesign-senftenberg", Component: WebdesignSenftenberg },
          { path: "webdesign-ruhland", Component: WebdesignRuhland },
          { path: "webdesign-schwarzheide", Component: WebdesignSchwarzheide },
          { path: "webdesign-hoyerswerda", Component: WebdesignHoyerswerda },
          { path: "webdesign-meissen", Component: WebdesignMeissen },
          { path: "webdesigner-dresden", Component: WebdesignerDresden },
          {
            path: "website-erstellen-lassen-dresden",
            Component: WebsiteErstellenLassenDresden,
          },
          { path: "agb", Component: Agb },
          { path: "impressum", Component: Impressum },
          { path: "datenschutz", Component: Datenschutz },
          { path: "widerruf", Component: Widerruf },
          { path: "blog", Component: Blog },
          { path: "blog/:slug", Component: BlogPost },
          { path: "*", Component: NotFound },
          { path: "fragebogen", Component: Fragebogen },
          { path: "konto-aktivieren", Component: AccountSetup },
          { path: "bestellung-erfolgreich/:shareSlug", Component: OrderSuccess },
        ],
      },
      {
        path: "/login",
        Component: Login,
      },
      {
        path: "/preview/:draftId",
        Component: DraftPreview,
      },
      {
        path: "/dashboard",
        element: (
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        ),
        children: [
          { index: true, Component: Dashboard },
          { path: "vertrag-abrechnung", Component: ProjectCheckout },
          { path: "kauf/:projectId", Component: ProjectCheckout },
        ],
      },
      {
        path: "/admin",
        element: (
          <AdminRoute>
            <AdminLayout />
          </AdminRoute>
        ),
        children: [
          { index: true, Component: AdminDashboard },
          { path: "projects", Component: AdminCustomers },
          { path: "projects/:projectId", Component: AdminProjectDetail },
        ],
      },
    ],
  },
]);
